import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

export const useDebitFreeMoteMutation = moteId => {
  return useGenericRequestHandler({
    route: `v1/c/debitFreeMotes/${moteId}`,
    method: 'POST'
  })
}
